module.exports = __webpack_public_path__ + "static/media/FilledBig.5029966b.svg";